<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/address-doctor/shared/address-doctor/address-doctor.component.ts
-->
<ng-template #anchor></ng-template>
